import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import { NavLink, Redirect, Route } from 'react-router-dom';
import RoutingService from '../../../services/RoutingService';
import DashboardBuilder from './dashboard-builder/DashboardBuilder';
import ViewBuilder from './view-builder/ViewBuilder';
const RS = new RoutingService();

class ComposerPanel extends ComponentHelper {
	componentDidMount() {
		console.log(RS.getCurrentConfiguration());
	}

	render() {
		return (
			<div className="composer-panel">
				<div className="tab-ctn hbox grow-1 animated fadeIn">
					<NavLink to={`/app-composer/${RS.getCurrentEnvironment()}/${RS.getCurrentApplication()}/dashboard`} className="tab vbox vcenter hcenter">
						Dashboard
					</NavLink>
					<NavLink to={`/app-composer/${RS.getCurrentEnvironment()}/${RS.getCurrentApplication()}/blackbook`} className="tab vbox vcenter hcenter">
						Black Book
					</NavLink>
				</div>
				<div className="tab-content">
					<Route
						exact
						path="/app-composer"
						render={() => <Redirect to={`/app-composer/${RS.getCurrentEnvironment()}/${RS.getCurrentApplication()}/dashboard`} />}
					/>
					<Route exact path={`/app-composer/${RS.getCurrentEnvironment()}/${RS.getCurrentApplication()}/dashboard`} component={DashboardBuilder} />
					<Route exact path={`/app-composer/${RS.getCurrentEnvironment()}/${RS.getCurrentApplication()}/blackbook`} component={ViewBuilder} />
				</div>
			</div>
		);
	}
}
export default ComposerPanel;



// WEBPACK FOOTER //
// ./src/views/app-composer/concierge/ComposerPanel.js